import get from 'lodash/get';
import { connect } from 'react-redux';
import JobCardComponent from './JobCardComponent.jsx';

const mapStateToProperties = (state, ownProperties) => {
	const { currentUser } = state.user;

	return {
		currentUser,
		companyId: get(currentUser, 'companyId'),
	};
};

const mapDispatchToProperties = () => {
	return {};
};

export default connect(
	mapStateToProperties,
	mapDispatchToProperties
)(JobCardComponent);
